import { lazy } from 'react';

// Partner & Plans Discovery - 5 components
// Browsing/discovery pages, often visited together

export const Partners = lazy(() => import(
  /* webpackChunkName: "partner" */ '../../pages/Partners'
));

export const Partner = lazy(() => import(
  /* webpackChunkName: "partner" */ '../../pages/Partner'
));

export const Plan = lazy(() => import(
  /* webpackChunkName: "partner" */ '../../pages/Plan'
));

export const Plans = lazy(() => import(
  /* webpackChunkName: "partner" */ '../../pages/Plans'
));
